// Static imports
import InsuredIndex from '@/views/member/insured/pages/'
import CasinoInsurePage from '@/views/member/insured/pages/casino'
import SlotInsurePage from '@/views/member/insured/pages/slot'
import SportInsurePage from '@/views/member/insured/pages/sport'
import InsureBetListPage from '@/views/member/insured/pages/insureBetList'
import SubInsureBetListPage from '@/views/member/insured/pages/subInsureBetList'
import ApplyMyPage from '@/views/member/insured/pages/applyMy'
import ApplyPage from '@/views/member/insured/pages/apply'
import ExchangePage from '@/views/member/insured/pages/exchange'
import AllTotalListPage from '@/views/member/insured/pages/alltotalList'

export default {
  name: 'insured',
  path: '/insured',
  component: InsuredIndex,
  redirect: {
    name: 'insureBetList'
  },
  meta: {
    layout: 'default',
    isActive: false,
    text: '보험 관리',
    icon: 'fas fa-handshake',
    code: 'LV040000'
  },
  children: [    
    {
      name: 'CasinoInsureSettings',
      path: '/insured/casino',
      component: CasinoInsurePage,
      meta: {
        menuMember: true,
        text: '카지노 보험 설정',
        exceptType: 'senior',
        code: 'LV040100'
      }
    },
    {
      name: 'SlotInsureSettings',
      path: '/insured/slot',
      component: SlotInsurePage,
      meta: {
        menuMember: true,
        text: '슬롯 보험 설정',
        exceptType: 'senior',
        code: 'LV040200'
      }
    },
    {
      name: 'SportInsureSettings',
      path: '/insured/sport',
      component: SportInsurePage,
      meta: {
        menuMember: true,
        text: '스포츠 보험 설정',
        exceptType: 'senior',
        code: 'LV040300'
      }
    },
    {
      name: 'insureBetList',
      path: '/insured/insureBetList',
      component: InsureBetListPage,
      meta: {
        menuMember: true,
        text: '상부보험베팅내역',
        isActive: false,
        exceptType: 'senior',
        code: 'LV040800'
      }
    },
    {
      name: 'subInsureBetList',
      path: '/insured/subInsureBetList',
      component: SubInsureBetListPage,
      meta: {
        menuMember: true,
        text: '하부보험베팅내역',
        isActive: false,
        exceptType: 'agency',
        code: 'LV040900'
      }
    },
    {
      name: 'insuredApplyMy',
      path: '/insured/apply/my',
      component: ApplyMyPage,
      meta: {
        menuMember: true,
        text: '보험변화내역',
        isActive: false,
        code: 'LV041000'
      }
    },
    {
      name: 'insuredApplyList',
      path: '/insured/apply',
      component: ApplyPage,
      meta: {
        menuMember: true,
        text: '하부보험금신청내역',
        isActive: false,
        exceptType: 'agency',
        code: 'LV041100'
      }
    },
    {
      name: 'insuredExchangeList',
      path: '/insured/exchange',
      component: ExchangePage,
      meta: {
        menuMember: true,
        text: '하부보험금환전내역',
        isActive: false,
        exceptType: 'agency',
        code: 'LV041200'
      }
    },
    {
      name: 'insureTotal',
      path: '/insured/alltotalList',
      component: AllTotalListPage,
      meta: {
        menuMember: true,
        text: '보험 정산내역',
        exceptType: '',
        code: 'LV040600'
      }
    },
  ]
}
